import React, {useEffect, useState, useRef, memo} from 'react';
import LiveGetStreamComponent from "../LiveGetStreamComponent/LiveGetStreamComponent";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {CamerasState} from "../../../store/cameras/types";
import {APIState} from "../../../store/API/types";
import { getStreamFromCamera, chooseService } from "../../../utils";
import UnSupportedFormatComponent from "../../reusable/UnSupportedFormatComponent/UnSupportedFormatComponent";
import SelectCameraComponent from "../../reusable/SelectCameraComponent/SelectCameraComponent";
import {setCurrentStream} from "../../../store/cameras/actions";
import { LayoutState } from '../../../store/layouts/types';
import ClearPaneComponent from '../../reusable/ClearPaneComponent';
import MapComponent from '../../reusable/MapComponent';
import WebPageComponent from '../../reusable/WebPageComponent';


interface Props {
    pane: number
}

type errorState = {
    error: boolean,
    msg: string
};

const InitLivemodePaneComponent: React.FC<Props> = ({pane}) => {
    const dispatch = useDispatch();
    const [ streamStatus, setStreamStatus ] = useState<errorState>({error: false, msg: ''});
    const { currentStreams, currentCameras } = useSelector<ApplicationState, CamerasState>(state => state.cameras);
    const { expandedVideoLayout, checkedPane } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const { cameras } = useSelector<ApplicationState, APIState>(state => state.API);
    const ref = useRef<HTMLDivElement>(null)
    const cam = currentCameras[pane];
    const currentStream = currentStreams[pane];

    const setOcularisStream = () => {
        const { error, stream } = getStreamFromCamera(cameras, cam.id, ref)
        if (!error) {
            setStreamStatus({error: false, msg: stream});
            dispatch(setCurrentStream(pane, stream, cam.id));
        } else {
            setStreamStatus({error: true, msg: stream})
        }
    }

    const setCayugaStream = () => {
        setStreamStatus({error: false, msg: ''});
        const stream = {
            codec:"h264",
            label: cam.name,
        };
        dispatch(setCurrentStream(pane, stream, cam.id));
    }
    
    const setStreamBasedOnServer = () => {
        chooseService(setOcularisStream, setCayugaStream);
    }

    useEffect(() => {
        if (cam) {
            setStreamBasedOnServer();
        }
    }, [cam]);

    useEffect(() => {
        if (cam && pane === checkedPane) {
            setStreamBasedOnServer();
        }
    }, [expandedVideoLayout]);

    return <div className={`videoContainer`} ref={ref}>
        {
            cam === null && <SelectCameraComponent />
        }
        {
            cam && <ClearPaneComponent pane={pane}/>
        }
        {
            (cam && streamStatus.error) && <UnSupportedFormatComponent data={streamStatus.msg}/> 
        }
        {
            (currentStream && cam && !streamStatus.error) && (cam.type === 'Map' 
                                                                ? <MapComponent mapId={cam.id} pane={pane} />
                                                                : cam.type === 'WebPage' 
                                                                        ? <WebPageComponent webPageId={cam.id}/>
                                                                        : <LiveGetStreamComponent pane={pane}
                                                                                    stream={currentStream}
                                                                                    cameraId={cam.id}
                                                                        />)
        }
    </div>
};

export default memo(InitLivemodePaneComponent)